import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	background-color: ${color.interface.white};
	border-radius: 5px;

	@media (max-width: 1100px) {
		min-height: 500px;
	}

	@media (max-width: 1000px) {
		width: 98%;
	}
`;

export const nameDynamicPage = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;

	> svg {
		cursor: pointer;
		color: ${color.interface.darkgray3};
		opacity: 0.8;
		font-size: 2rem;
	}

	> h3 {
		font-size: 1.5rem;
		color: ${color.interface.darkgray3};
		font-weight: 900;
	}
`;

export const boxListOptions = styled.div`
	width: 100%;
	height: 100%;
	max-height: 100%;
	padding: 8px;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: center;
	justify-content: flex-start;
	overflow: auto;
	transition: all ease 0.5s;
`;

export const titleList = styled.div`
	width: 100%;
	padding: 1.5rem;
	padding-bottom: 0;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: flex-start;
	justify-content: flex-start;

	> h3 {
		font-size: 1.5rem;
		color: ${color.interface.darkgray3};
		font-weight: 900;
	}
`;

export const iconAndDescription = styled.div`
	display: flex;
	gap: 0.5rem;
	align-items: center;
	justify-content: space-between;

	> p {
		color: ${color.interface.darkgray3};
		opacity: 0.8;
		font-size: 1.3rem;
		width: 80%;
	}

	> svg {
		color: ${color.interface.darkgray3};
		opacity: 0.8;
		font-size: 4rem;
	}
`;

export const loadBox = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem;
	border-radius: 5px;
	background-color: ${color.interface.white};
`;

export const noOptions = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem;
	border-radius: 5px;

	> p {
		font-size: 1.4rem;
		font-family: nunito-bold;
		color: ${color.interface.darkgray};
	}
`;
